import BouncingLogo from "../bouncingLogo/bouncingLogo";
import { FloatButton } from "antd";
import { BsFillSunFill } from "react-icons/bs";

export default function BlackScreen(isActive) {

  return (
    <>
      <div className="fullscreen-black">
        <BouncingLogo />
        <FloatButton
          href="/"
          icon={<BsFillSunFill />}
          tooltip={<div>Exit Dark Mode</div>}
        />{" "}
      </div>
    </>
  );
}
